export default "__VITE_ASSET__Ckk201vM__"